/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';

import useAuthAPI from '../../hooks/network/useAuthAPI';

import LoginComponent from '../../components/login/Login';
import VerifyOtp from '../../components/login/VerifyOtp';
import LoginBanner from '../../assets/images/LoginBanner.png';
import NatSteelLogo from '../../assets/logos/NatSteelLogo.png';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useSettingsAPI from '../../hooks/network/useSettingsAPI';

function Login() {
  const [otpInfo, setOtpInfo] = useState(null);
  const [sliderData, setSliderData] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const { isLoading, login, loginByOTP } = useAuthAPI();
  const { getConfigByGroupAndKey } = useSettingsAPI();

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    getSliderData();
  }, []);

  const getSliderData = async () => {
    try {
      const config = await getConfigByGroupAndKey('loginSettings', 'loginSettings');
      if (!config?.value) return;
      setSliderData({ ...JSON.parse(config?.value) });
    } catch {}
  };

  const handleSubmit = async (values) => {
    const payload = {
      userName: values?.userName?.toLowerCase(),
      mailOTP: values?.mailOTP,
    };
    await login(payload).then(
      (result) => {
        setOtpInfo(result.otpInfo);
        setErrorMessage('');
      },
      (error) => {
        setErrorMessage(error?.message);
      },
    );
  };

  const handleOtpSubmit = async (values) => {
    await loginByOTP(otpInfo.userName, values?.code).then(null, (error) => {
      setErrorMessage(error.message);
    });
  };

  return (
    <div className='bg-white'>
      <section className='App-login app-container lg:pl-0'>
        <div className='relative flex h-full min-h-screen flex-col-reverse items-center justify-center lg:flex-row lg:justify-center'>
          <div className='relative hidden w-full lg:block lg:max-w-[70%]'>
            {sliderData?.sliderImageUrl ? (
              <div className='flex h-screen max-w-full items-center justify-center'>
                <img
                  className='h-full object-cover'
                  src={sliderData?.sliderImageUrl || LoginBanner}
                  alt='loginBanner'
                />
              </div>
            ) : (
              <div className='h-screen w-full bg-black' />
            )}
            <div
              className='absolute bottom-[15vh] w-full px-14 py-5'
              style={{ color: sliderData?.textColor || '#FFF' }}
            >
              <div className=''>
                <Slider {...settings}>
                  {sliderData?.slides?.map((s, i) => (
                    <div
                      key={i}
                      className='mx-2 !flex flex-col items-center justify-center gap-5 px-5'
                    >
                      <div className='text-3xl xxl:text-4xl'>
                        <h2 className='text-center'>{s?.title}</h2>
                      </div>
                      <div>
                        <p className='text-center'>{s?.desc}</p>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
          <div className='w-full text-left sm:max-w-[539px] lg:ml-24 lg:mt-0 lg:max-w-[30%] xl:min-w-[300px]'>
            {otpInfo != null ? (
              <VerifyOtp
                isLoading={isLoading}
                onSubmit={handleOtpSubmit}
                errorMessage={errorMessage}
                onClickSendOtpToMail={handleSubmit}
                {...otpInfo}
              />
            ) : (
              <LoginComponent
                isLoading={isLoading}
                onSubmit={handleSubmit}
                errorMessage={errorMessage}
              />
            )}
            <div className='absolute right-0 bottom-6 lg:hidden'>
              <p>Powered by</p>
              <img src={NatSteelLogo} alt={NatSteelLogo} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

Login.propTypes = {};

export default Login;
